export default __webpack_public_path__ + "static/media/agent4.4502d385.png";